import type { DetailedHTMLProps, HTMLAttributes } from 'react'

interface ApplePayButtonElementAttributes extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  buttonstyle?: 'black' | 'white' | 'white-outline'
  type?: string
  locale?: string
  disabled?: boolean
  onclick?: () => void
}

declare module 'react/jsx-runtime' {
  namespace JSX {
    interface IntrinsicElements {
      'apple-pay-button': ApplePayButtonElementAttributes
    }
  }
}

export interface ApplePayButtonProps {
  onClick: () => void
  disabled?: boolean
}

/**
 * Apple's own `<apple-pay-button>` custom element, registered globally by the
 * Apple Pay SDK script once `useApplePay`'s `mountApplePay` loads it — renders
 * correctly on Safari and on third-party browsers alike. Callers gate
 * rendering on `AdyenDropin`'s `applePayAvailable`. See specs/app/index.md::Decisions.
 */
export function ApplePayButton({ onClick, disabled }: ApplePayButtonProps) {
  return (
    <apple-pay-button
      buttonstyle="black"
      type="plain"
      disabled={disabled || undefined}
      onclick={disabled ? undefined : onClick}
    />
  )
}
